/* eslint-disable functional/immutable-data */
/* eslint-disable sonarjs/prefer-immediate-return */

export function setCookie(cname: string, cvalue: string) {
  document.cookie = cname + "=" + cvalue + "; path=/; Domain=" + getDomain();
}

function getDomain() {
  const portParts = window.location.host.split(":");
  const parts = portParts[0].split(".");
  const domain =
    parts.length === 1
      ? parts[0]
      : parts[parts.length - 2] + "." + parts[parts.length - 1];

  return domain;
}
